import './Footer.css'

const Footer = () => {
  return (
    <footer>
      <a href='https://github.com/PremanandChowdhury/Hercules'>Repo Link</a>
    </footer>
  )
}

export default Footer
